import ReactGA from "react-ga4";
import { gaId } from "./constant";

// Initialize GA
export const initGA = () => {
  if(gaId) {
    ReactGA.initialize(gaId, { debug: true });
  }
};

// // Default parameters for all events
const getDefaultParameters = () => {
  // const userInfo = JSON.parse(Cookies.get("userInfo") || "{}");
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    if (!userInfoStr) {
      return {};
    }
    const userInfo = JSON.parse(userInfoStr);
    if (userInfo && typeof userInfo === 'object' && Object.keys(userInfo).length > 0) {
      return {
        employee_id: userInfo?.employeeId || "Unknown",
        user_role: userInfo?.role || "Unknown",
        employee_name: userInfo?.employeeName || "Unknown",
        branch: "Unknown",
        zone: "Unknown",
        region:"Unknown",
      };
    }
  } catch (error) {
    console.error("Error parsing userInfo from localStorage:", error);
  }
  return {};
};

// Generic event tracking function
export const trackEvent = (eventName, additionalParams = {}) => {
  const defaultParams = getDefaultParameters();
  ReactGA.event(eventName, {
    ...defaultParams,
    ...additionalParams,
  });
};

// Page View Tracking
export const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Event Configuration
export const EVENT_TYPES = {
  LOGIN: {
    ATTEMPT: "login",
    SUCCESS: "login_successful",
    FAILED: "login_failed",
  },
  LOGOUT: "logout",
  SESSION_EXPIRED: "logout_due_session_expired",
  PAGE_VISIT: "page_visits",
  PASSWORD: {
    RESET_INITIATED: "reset_password",
    RESET_SUCCESS: "password_reset",
    OTP_SENT: "otp_sent",
    OTP_VERIFIED: "otp_verified",
  },
};